import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import { Button } from "components/bootstrap";
import Spinner from "components/common/Spinner";
import ConfirmDialog from "components/common/ConfirmDialog";
import ConfirmLeaveDialog from "components/common/ConfirmLeaveDialog";
import usePluginEntities from "hooks/usePluginEntities";
import usePermissions from "hooks/usePermissions";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import ThemeSection from "./ThemeSection";
const Header = styled.h4`
  margin: 15px 0 3px;
`;
const SectionWrap = styled.ul(
  ({ theme }) => css`
    margin: 0;
    padding: 0 0 18px;
    list-style: none;

    li {
      padding: 3px 6px;
      display: flex;
      align-items: center;
      justify-content: center;

      &:nth-child(even) {
        background-color: ${theme.colors.variant.lightest.default};
      }

      > span {
        flex: 5;
      }

      > div,
      > strong {
        flex: 1;
        text-align: center;
      }
    }
  `
);
const StyledButton = styled(Button)`
  margin: 0 12px;
`;
const ThemeEditor = () => {
  var _a, _b;
  const [showConfirmRevert, setShowConfirmRevert] = useState();
  const [showConfirmReset, setShowConfirmReset] = useState();
  const themeCustomizer = usePluginEntities("customization.theme.customizer");
  const useThemeCustomizer = (_b = (_a = themeCustomizer == null ? void 0 : themeCustomizer[0]) == null ? void 0 : _a.hooks) == null ? void 0 : _b.useThemeCustomizer;
  const { isPermitted } = usePermissions();
  const {
    currentColors,
    isLoadingCustomColors,
    isDefaultColors,
    isSaved,
    onChangeTheme,
    onResetTheme,
    onRevertTheme,
    onSaveTheme
  } = useThemeCustomizer();
  const sendTelemetry = useSendTelemetry("theme-editor");
  const toggleConfirmRevert = () => {
    setShowConfirmRevert(!showConfirmRevert);
  };
  const toggleConfirmReset = () => {
    setShowConfirmReset(!showConfirmReset);
  };
  const handleRevertTheme = () => {
    onRevertTheme().then(() => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.CUSTOMIZATION.THEME_REVERTED, {
        app_pathname: "customization"
      });
      toggleConfirmRevert();
    });
  };
  const handleResetTheme = () => {
    onResetTheme().then(() => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.CUSTOMIZATION.THEME_RESETED, {
        app_pathname: "customization"
      });
      toggleConfirmReset();
    });
  };
  if (!isPermitted("clusterconfigentry:edit")) {
    return null;
  }
  return !isLoadingCustomColors ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Header, { id: "themeGeneralSection" }, "General"), /* @__PURE__ */ React.createElement(SectionWrap, { title: "modify global theme general colors" }, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("span", null), /* @__PURE__ */ React.createElement("strong", null, "Light"), /* @__PURE__ */ React.createElement("strong", null, "Dark"), /* @__PURE__ */ React.createElement("span", null)), /* @__PURE__ */ React.createElement(ThemeSection, { currentThemeColors: currentColors, onChange: onChangeTheme, section: "general" })), /* @__PURE__ */ React.createElement(Header, { id: "themeVariantsSection" }, "Variants"), /* @__PURE__ */ React.createElement(SectionWrap, { title: "modify global theme variant colors" }, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("span", null), /* @__PURE__ */ React.createElement("strong", null, "Light"), /* @__PURE__ */ React.createElement("strong", null, "Dark"), /* @__PURE__ */ React.createElement("span", null)), /* @__PURE__ */ React.createElement(ThemeSection, { currentThemeColors: currentColors, onChange: onChangeTheme, section: "variant" })), /* @__PURE__ */ React.createElement(
    Button,
    {
      onClick: toggleConfirmRevert,
      bsStyle: "warning",
      bsSize: "xs",
      disabled: isSaved,
      title: "Revert to the Previous Save"
    },
    "Revert"
  ), /* @__PURE__ */ React.createElement(
    StyledButton,
    {
      onClick: toggleConfirmReset,
      bsStyle: "danger",
      bsSize: "xs",
      disabled: isDefaultColors,
      title: "Reset to Default Colors"
    },
    "Reset"
  ), /* @__PURE__ */ React.createElement(Button, { onClick: onSaveTheme, bsStyle: "primary", bsSize: "xs", disabled: isSaved, title: "Save Custom Theme" }, "Save Theme"), /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: showConfirmRevert,
      onConfirm: handleRevertTheme,
      onCancel: toggleConfirmRevert,
      title: "Are you sure?"
    },
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, "Reverting your theme to the last save will lose any unsaved changes."), /* @__PURE__ */ React.createElement("p", null, "Do you wish to continue?"))
  ), /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: showConfirmReset,
      onConfirm: handleResetTheme,
      onCancel: toggleConfirmReset,
      title: "Are you sure?"
    },
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, "Resetting your theme will remove all your custom changes and load in default colors."), /* @__PURE__ */ React.createElement("p", null, "Do you wish to continue?"))
  ), !isSaved && /* @__PURE__ */ React.createElement(ConfirmLeaveDialog, { question: "You have unsaved Theme changes. Are you sure you want to abandon them?" })) : /* @__PURE__ */ React.createElement(Spinner, null);
};
export default ThemeEditor;
